import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';

// Tabs
import ScheduleGradeFleetTab from './Elements/ScheduleGradeFleetTab';
import ScheduleGradeEditTabAlternate from './Elements/ScheduleGradeEditTabAlternate';
import ScheduleGradeInitialsTab from './Elements/ScheduleGradeInitialsTab';
import ScheduleGradeEquipmentChiefTab from './Elements/ScheduleGradeEquipmentChiefTab';
import ScheduleGradeVacationsTab from './Elements/ScheduleGradeVacationsTab';
import ScheduleGradeTrainingsTab from './Elements/ScheduleGradeTrainingsTab';
import ScheduleGradeStaffRemainingAlternateTab from './Elements/ScheduleGradeStaffRemainingAlternateTab';
import getLocale from '../../i18n/getLocale';

class ScheduleGradesAlternate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      key: 1,
      schedule_grade: {},
      schedule: {},
      aircraft_model: {},
      grade: {},
      grade_alternate: {},
      grade: {},
      grade_extra_main: {},
      aircrafts_available: {},
      staffs_list: null,
      aircrafts_remaining: {},
      bases: {},
      base: {},
      aircrafts_list: {},
      bases_active_list: {},
      schedule_days: {},
      types_list: [],
      initials_colors: {},
      initials: {},
      schedule_grade_initials: {},
      schedule_grade_initials_secondary: {},
      schedule_grade_initials_vacation: {},
      chiefs: {},
      remaining_staffs: {},
      remaining_staffs_list: {},
      schedule_used_regime_list: {},
      modal_alert: false,
      alerts: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.updateData = this.updateData.bind(this);
    this.viewAlerts = this.viewAlerts.bind(this);
    this.closeModalAlert = this.closeModalAlert.bind(this);

    this.updateDataEditMode = this.updateDataEditMode.bind(this);
    this.toggleEditMode = this.toggleEditMode.bind(this);
    this.resetGrade = this.resetGrade.bind(this);
    this.saveGrade = this.saveGrade.bind(this);
    this.generatePersonalAlerts = this.generatePersonalAlerts.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  // Fecha modal
  closeModalAlert(event){
    this.setState({modal_alert: false, alerts: {}});
  }


  // gero os dados do modal de alertas da grade
  viewAlerts (schedule_id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/gerar/alertas/' + schedule_id + '/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({alerts: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal_alert: true});
      })
    });
  }

  updateData (responseJson) {
    this.setState({updated: 1, show_select: 0}, this.loadData(responseJson));
  }

  loadData (event) {
    var self = this;
    var aircraft_model_id = 0;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/info/alternativa/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/escalas');
        if (responseJson.data.schedule_grade) {
          aircraft_model_id = responseJson.data.schedule_grade.schedule.aircraft_model_id;
          self.setState({schedule_grade: responseJson.data.schedule_grade});
          self.setState({schedule: responseJson.data.schedule_grade.schedule});
          self.setState({base: responseJson.data.schedule_grade.schedule.base});
          self.setState({schedule_grade_initials: responseJson.data.schedule_grade_initials.data});
          self.setState({schedule_grade_initials_secondary: responseJson.data.schedule_grade_initials_secondary});
          self.setState({schedule_grade_initials_vacation: responseJson.data.schedule_grade_initials_vacation});
        }
        if (responseJson.status === 'success') {
          if (responseJson.data.schedule_grade.schedule.type === 'mestre') {
            self.setState({remaining_staffs: responseJson.data.remaining_staffs.master});
            self.setState({remaining_staffs_list: responseJson.data.remaining_staffs_list.master});
          } else {
            self.setState({remaining_staffs: responseJson.data.remaining_staffs.cvo});
            self.setState({remaining_staffs_list: responseJson.data.remaining_staffs_list.cvo});
          }
          self.setState({schedule_days: responseJson.data.schedule_days});
          self.setState({schedule_staff_trainings: responseJson.data.schedule_staff_trainings.data});
          self.setState({grade_alternate: responseJson.data.grade_alternate.data});
          self.setState({staffs_list: responseJson.data.staffs_list.data});
          self.setState({types_list: responseJson.data.types_list.data});
          self.setState({initials_colors: responseJson.data.initials_colors.data});
          self.setState({initials: responseJson.data.initials.data});
          self.setState({chiefs: responseJson.data.chiefs.data});
          self.setState({schedule_used_regimes: responseJson.data.schedule_used_regimes});
          self.setState({schedule_used_regime_list: responseJson.data.schedule_used_regime_list});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  updateDataEditMode (grade) {
    this.setState({updated: 1, show_select: 0, grade_alternate: {...grade.grade_alternate}});
    this.setState({overlay: {message: '', type: '', status: 'closed'}});
  }

  resetGrade () {
    if(window.confirm(this.locale.GradesDeEscala.GradesDeEscalaAlternativa.descartarAlteracoes)) {
      this.setState({overlay: {message: '', type: '', status: 'open'}});
      this.toggleEditMode();
      this.updateData();
    }
  }

  saveGrade () {
    var self = this;
    if(window.confirm(this.locale.GradesDeEscala.GradesDeEscalaAlternativa.salvarAlteracoes)) {
      this.handleAlert('', '', 'open');
      var datasave = {
        grade: this.state.grade,
        grade_alternate: this.state.grade_alternate,
        id: self.props.match.params.id,
      };
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/edicao/salvar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.toggleEditMode();
            self.updateData(responseJson);
          } else {
            self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Toggle de modo de edição
  toggleEditMode(){
    if (this.state.edit_mode) {
      this.setState({edit_mode: false});
    } else {
      this.setState({edit_mode: true});
    }
  }

  // gero os dados do modal de alertas da grade
  generatePersonalAlerts (schedule_grade_aircraft_staff_id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/gerar/alerta/pessoal/' + schedule_grade_aircraft_staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({alerts: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal_alert: true});
      })
    });
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={self.handleLoaded} />
  <Overlay overlay={self.state.overlay} handleAlert={self.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.GradesDeEscala.GradesDeEscalaAlternativa.titulo} - {self.state.schedule.type_str} - {self.state.base.name} - {self.state.schedule.name}</h3>
      {
        self.state.schedule.type === 'mestre' ?
          <Link to={"/escala/mestre-de-carga/editar/" + self.state.schedule.id} className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
          :
          <Link to={"/escala/cvo/editar/" + self.state.schedule.id} className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      }
      <div className="btn-group button-inline pull-right">
        <button onClick={() => { self.viewAlerts(self.state.schedule.id) }} className="btn btn-warning"><i className="fa fa-warning"></i> {this.locale.GradesDeEscala.GradesDeEscalaAlternativa.botaoExibirAlertas}</button>
      </div>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={self.state.key} onSelect={self.handleNavTab.bind(self, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.GradesDeEscala.GradesDeEscalaAlternativa.tabEscala.tituloTab}>
          <ScheduleGradeEditTabAlternate schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id}  updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} grade_alternate={self.state.grade_alternate} staffs_list={self.state.staffs_list} remaining_staffs_list={self.state.remaining_staffs_list} schedule_used_regime_list={self.state.schedule_used_regime_list} schedule_used_regimes={self.state.schedule_used_regimes} schedule_grade={self.state.schedule_grade} schedule_days={self.state.schedule_days} type={self.state.schedule.type} types_list={self.state.schedule_grade_initials} initials_colors={self.state.initials_colors} edit_mode={self.state.edit_mode} toggleEditMode={self.toggleEditMode} updateDataEditMode={self.updateDataEditMode} generatePersonalAlerts={self.generatePersonalAlerts} generateAircraftAlerts={self.generateAircraftAlerts} staffs_by_id={self.state.staffs_by_id} resetGrade={self.resetGrade} saveGrade={self.saveGrade} />
        </Tab>
        <Tab eventKey={3} title={this.locale.GradesDeEscala.GradesDeEscalaAlternativa.tabForaDaEscala.tituloTab}>
          <ScheduleGradeStaffRemainingAlternateTab date_finish={self.state.schedule.date_finish_str} date_start={self.state.schedule.date_start_str} schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id}  updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} remaining_staffs={self.state.remaining_staffs} schedule_grade_initials_secondary={self.state.schedule_grade_initials_secondary} schedule_grade_initials_vacation={self.state.schedule_grade_initials_vacation} types_list={self.state.types_list} />
        </Tab>
        <Tab eventKey={5} title={this.locale.GradesDeEscala.GradesDeEscalaAlternativa.tabTreinamentos.tituloTab}>
          <ScheduleGradeTrainingsTab schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id}  updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} schedule_staff_trainings={self.state.schedule_staff_trainings} />
        </Tab>
        <Tab eventKey={6} title={this.locale.GradesDeEscala.GradesDeEscalaAlternativa.tabSiglas.tituloTab}>
          <ScheduleGradeInitialsTab schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id} updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} initials={self.state.initials} />
        </Tab>
      </Tabs>
    </div>
  </div>
  <Modal show={self.state.modal_alert} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.GradesDeEscala.GradesDeEscalaAlternativa.tituloRevisao} {self.state.schedule_grade.revision} - {self.state.aircraft_model.model} - {self.state.schedule.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
    {
      (typeof self.state.alerts.global_alerts !== 'undefined') ?
      <div>
        {Object.keys(self.state.alerts.global_alerts).map(function(k) {
          var alert = self.state.alerts.global_alerts[k];
          if (alert.status === 'danger') {
            return(
              <div className={"box-alert box-alert-" + alert.color}>
                <h4><strong>{alert.title}</strong></h4>
                  <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
              </div>
            );
          } else {
            return(
              ''
            );
          }
        })}
        <hr/>
      </div>
      :
      ''
    }
    {
      (typeof self.state.alerts.personal_alerts !== 'undefined') ?
      <div>
        {Object.keys(self.state.alerts.personal_alerts).map(function(nickname) {
          var alerts = self.state.alerts.personal_alerts[nickname];
          return(
            <div>
              <h4><strong>{nickname}</strong></h4>
              {Object.keys(alerts).map(function(k) {
                var alert = alerts[k];
                if (alert.status === 'danger') {
                  return(
                    <div className={"box-alert box-alert-" + alert.color}>
                        <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                    </div>
                  );
                } else {
                  return(
                    ''
                  );
                }
              })}
              <hr/>
            </div>
          );
        })}
      </div>
      :
      ''
    }

    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default ScheduleGradesAlternate;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/ScheduleGradesAlternate.js